export {
  type AppWordPronunciationCard,
  appWordPronunciationCardTable,
} from "#app-word-pronunciation-card-table";
